import { UserManager, UserManagerSettings } from "oidc-client";

export const ssoConfig: UserManagerSettings = {
  authority: "https://mnemosine.aasp.org.br",
  client_id: "lex",
  redirect_uri: `https://plataformaip.lex.com.br/sso/callback`,
  post_logout_redirect_uri: `https://plataformaip.lex.com.br/sso/logout`,
  response_type: "id_token token",
  response_mode: "fragment",
  scope: "openid profile",
  filterProtocolClaims: true,
  loadUserInfo: true,
};

export const ssoUserManager = new UserManager(ssoConfig);
